import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('LotSize?page=' + page,  {params});
    }, 
    show(id) {
        return Service().get('LotSize/show/'+id);
    },    
    create(params) {
        return Service().post('LotSize/create', params);
    },
    update(id, params) {
        return Service().post('LotSize/update/'+id, params);
    },
    delete(id) {
        return Service().post('LotSize/delete/'+id);
    }
}